import { Icon, IconProps } from '~/components/Icon/Icon';

export type BellProps = IconProps & {
  dot?: boolean;
};
export const Bell = ({ dot, ...props }: BellProps) => (
  <Icon
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M18.7092 21.7955C18.7092 23.8624 17.0336 25.538 14.9667 25.538C12.8997 25.538 11.2241 23.8624 11.2241 21.7955"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9661 4.53809C18.6248 4.53809 21.5907 7.50424 21.5903 11.163L21.5903 11.3684C21.5902 13.1279 22.176 14.8343 23.2506 16.2201L23.4453 16.4613C24.6436 17.8878 25.3005 18.6601 25.3005 20.5231V20.5231C25.3005 20.8325 25.0497 21.0834 24.7403 21.0834H5.19364C4.8839 21.0834 4.63281 20.8323 4.63281 20.5225V20.5225C4.63281 18.7633 5.21847 18.0884 6.29257 16.7025L6.48717 16.4613C7.68494 15.0348 8.34161 13.2317 8.34178 11.369L8.3418 11.1618C8.34213 7.50351 11.3078 4.53809 14.9661 4.53809V4.53809Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    {dot && <circle cx="19.75" cy="4.75" r="3.5" fill="#FF334B" stroke="white" />}
  </Icon>
);
